import React, { useState, useMemo, useEffect, useRef } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import { debounce } from 'lodash'
import { v4 as uuidv4 } from 'uuid';
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react'

// import mention from "quill-mention";
import 'react-quill/dist/quill.snow.css'
import 'quill-mention/dist/quill.mention.css'
import 'quill-mention'
import ImageModal from '../components/Comments/ImageModal'



import { useSelector } from 'react-redux'
import { useEditModal } from '../context/ShowEditModalQuill'
import ReactToolTip from './ReactToolTip'

import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.snow.css'
import 'react-tooltip/dist/react-tooltip.css'
import '../styles/richTextStyle.css'
import { useTheme } from '../context/ThemeContext'
import { useAuth } from '../modules/auth'
import { highlightPickerColors } from '../utils/quillColors'
import { extractMentionText } from '../utils/extractMentionText'
import { createSafeHtml } from '../utils/htmlSanitizer'

const Size = Quill.import('formats/size')
Size.whitelist = ['extra-small', 'small', 'medium', 'large']
Quill.register(Size, true)

const Font = Quill.import('formats/font')
Font.whitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lucida']
Quill.register(Font, true)

const Link = Quill.import('formats/link')
Link.sanitize = function (url: any) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`
  }
  return url;
}

// const Block = Quill.import('pa')
// Block.tagName = 'P'
// Block.className = 'spacer'
// Quill.register(Block, true)

// Quill.register('modules/mention', mention, true);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
interface TextEditorProps {
  setEditorTags?: React.Dispatch<React.SetStateAction<any | null>>
  setEditor: React.Dispatch<React.SetStateAction<string | null>>
  editor: string | null
  placeholder: string
  forTitle?: string
  tocHeading?: any
  role?: string
  boardId?: string
  tabIndex?: any
  onFocus?: any
  handleFormSubmission?: () => void
  optionsForSendAlert?: any
  setDesc?: any
  setMentions?: any
  retainMentions?: any
  uniqueId?: any
  isHome?: boolean
  currentCardOrPage?: any
  isExpandedModal?: boolean
}

const MemoizedTextEditor: React.FC<TextEditorProps> = ({
  setEditor,
  editor,
  placeholder,
  tocHeading,
  // forTitle,
  role,
  boardId,
  tabIndex,
  onFocus,
  optionsForSendAlert,
  // setDesc,
  handleFormSubmission, setEditorTags = () => { },
  setMentions, retainMentions, isHome,
  uniqueId,
  currentCardOrPage,
  isExpandedModal
}): any => {
  const { setShowEditModalQuill, setCard, pushToHistory, setExpandedFromSource } = useEditModal()
  // const { setShowEditPageModalQuill, setPage } = useEditPageModal()
  const editRef: any = useRef()
  const quillRef: any = useRef(null)
  const isExpandedModalRef = useRef(isExpandedModal)
  const { theme } = useTheme()
  const { currentUser } = useAuth()
  const { fullName } = currentUser?.data.user
  useEffect(() => {
    if (quillRef.current && onFocus) {
      quillRef.current.focus();  // Focus editor when triggered
    }
  }, [onFocus]);

  useEffect(() => {
    isExpandedModalRef.current = isExpandedModal
  }, [isExpandedModal])

  const [isVideoSrcGet, setIsVideoSrcGet] = useState(false)
  const [cardSelected, setCardSelected] = useState<any>(null)
  const [pageSelected, setPageSelected] = useState<any>(null)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [showHighlightPicker, setShowHighlightPicker] = useState(false)
  const [highlightColor, setHighlightColor] = useState('#ffff00')
  const [showTextColorPicker, setShowTextColorPicker] = useState(false)
  const [textColor, setTextColor] = useState('#000000')
  const emojiPickerRef = useRef<HTMLDivElement>(null)
  const highlightPickerRef = useRef<HTMLDivElement>(null)
  const colorInputRef = useRef<HTMLInputElement>(null)
  const textColorPickerRef = useRef<HTMLDivElement>(null)
  const textColorInputRef = useRef<HTMLInputElement>(null)
  const savedCursorPosition = useRef<any>(null)

  // const [cursorRange, setCursorRange] = useState({ min: null, max: null,start: null });
  // const { allCurrentUserCards } = useSelector((state: any) => state.cardReducer)
  const { pagesByLoggedInUser: pages } = useSelector((state: any) => state.pageReducer)
  const { allCurrentUserCards } = useSelector((state: any) => state.cardReducer)

  const handleMouseover = (id: string) => {
    const cardInfo: any = allCurrentUserCards?.find((card: any) => `${card?.key.trim()}` === id)
    const pageInfo: any = pages?.find((page: any) => `${page?.id}` === id)
    setShowEditModalQuill(false)
    // setShowEditPageModalQuill(false)
    if (cardInfo) {
      setCardSelected(cardInfo)
    }
    if (pageInfo) {
      setPageSelected(pageInfo)
    }
  }

  const debouncedOnChange = debounce(handleMouseover, 300)

  const handleCopy = (e: ClipboardEvent) => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;
    // Get the selected text
    const range = editor.getSelection();
    if (!range || range.length === 0) return;
    // Create a temporary div to hold the selected content
    const selectedContent = editor.getContents(range.index, range.length);
    // Convert Delta to HTML
    const tempDiv = document.createElement('div');
    const tempQuill = new Quill(tempDiv);
    tempQuill.setContents(selectedContent);
    // Get the HTML and add our custom identifier
    let html = tempDiv.querySelector('.ql-editor')?.innerHTML || '';
    const simpleText = (tempDiv.querySelector('.ql-editor') as HTMLElement)?.innerText || '';
    // Generate a unique ID for this copy operation
    const copyId = uuidv4();
    // Add our source identifier to all copied content
    html = `<div data-editor-source="${copyId}" data-editor-theme="${theme}" data-editor-app="your-app-name">${html}</div>`;
    // Set the clipboard data

    e.clipboardData?.setData('text/html', html);
    e.clipboardData?.setData('text/plain', simpleText);
    // window.navigator.clipboard.write([clipboardItem]);
    e.preventDefault(); // Prevent default copy to control the process
  };

  const handlePaste = (e: ClipboardEvent) => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const clipboardData = e.clipboardData || (window as any).clipboardData;
    if (!clipboardData) return;
    const files = clipboardData.files
    if (files && files.length > 0) {
      // Check if there are any image files
      const hasImageFiles = Array.from(files).some((file: any) => file.type.startsWith('image/'));

      if (hasImageFiles) {
        Array.from(files).forEach((file: any) => {
          if (file.type.startsWith('image/')) {
            // Handle image pasting
            const reader = new FileReader();
            reader.onload = (loadEvent) => {
              const range = editor.getSelection();
              if (range) {
                const imageUrl = loadEvent.target?.result as string;
                // Insert image at cursor position
                if (range?.length > 0) editor.deleteText(range.index, range.length);
                editor.insertEmbed(range.index, 'image', imageUrl);

                const newContent = editor.root.innerHTML;
                setEditor(newContent);
                // Move cursor after the image
                setTimeout(() => {
                  editor.setSelection(range.index + 1, 0);
                }, 50);
              }
            };
            reader.readAsDataURL(file);
          }
        });
        // CRITICAL: Return early to prevent HTML processing below
        return;
      }
    }
    const html = clipboardData?.getData('text/html');
    if (!html) {
      // Handle plain text pasting if no HTML
      editor.focus(); // Ensure the editor is active
      const text = clipboardData.getData('text/plain');
      if (text) {
        let range = editor.getSelection();

        // If no selection but editor has focus, get cursor position
        if (!range && editor.hasFocus()) {
          const cursorPosition = editor.getLength() - 1;
          range = { index: cursorPosition, length: 0 };
        }
        // If no selection and no focus, use start of document
        else if (!range) {
          range = { index: 0, length: 0 };
        }
        if (range) {
          // Insert the plain text
          if (range?.length > 0) editor.deleteText(range.index, range.length);
          editor.insertText(range.index, text);

          // Update editor content state
          const newContent = editor.root.innerHTML;
          setEditor(newContent);

          // Position cursor after the inserted text
          setTimeout(() => {
            const newCursorPosition = Math.min(
              range.index + text.length,
              // editor.getLength() - 1
            );
            editor.setSelection(newCursorPosition, 0);

            // Try to trigger mention dropdown for pasted task IDs
            // This will delete the pasted text and re-insert with keyboard simulation
            triggerMentionForPastedId(editor, text, range.index);
          }, 150);
        }
      }
      return;
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    let brCount = 0;
    // Check if content is from our editor by looking for our data attribute
    const editorContent = tempDiv.querySelector('[data-editor-source]');
    if (editorContent) {
      // This is content from our editor - preserve ALL formatting
      const sourceTheme = editorContent.getAttribute('data-editor-theme');
      const contentToInsert = editorContent.innerHTML;
      // Determine if we need to adapt colors for theme changes
      const needsThemeAdaptation = sourceTheme !== theme;
      if (needsThemeAdaptation) {
        // Theme adaptation for content from our editor in different theme
        const elementsToAdapt = tempDiv.querySelectorAll('*');
        elementsToAdapt.forEach((element: any) => {
          // Adapt specific theme colors we know about
          if (theme === 'dark') {
            // Adapt light theme colors to dark theme
            if (element.style.backgroundColor === 'rgb(255, 255, 255)') {
              element.style.backgroundColor = 'transparent';
            }
            if (element.style.color === 'rgb(0, 0, 0)' || element.style.color === 'rgb(24, 28, 50)') {
              element.style.color = 'rgb(255, 255, 255)';
            }
          } else {
            // Adapt dark theme colors to light theme
            if (element.style.backgroundColor === 'rgb(44, 58, 77)' || element.style.backgroundColor === 'rgb(30, 30, 30)') {
              element.style.backgroundColor = 'transparent';
            }
            if (element.style.color === 'rgb(255, 255, 255)' || element.style.color === 'rgb(200, 200, 200)') {
              element.style.color = 'rgb(0, 0, 0)';
            }
          }
        });
      }

      editor.focus(); // Ensure the editor is active
      let range = editor.getSelection();
      // If no selection but editor has focus, get cursor position
      if (!range && editor.hasFocus()) {
        const cursorPosition = editor.getLength() - 1;
        range = { index: cursorPosition, length: 0 };
      }
      // If no selection and no focus, use start of document
      else if (!range) {
        range = { index: 0, length: 0 };
      }

      if (!range) return;
      // Insert with all formatting preserved
      if (range?.length > 0) editor.deleteText(range.index, range.length);

      editor.clipboard.dangerouslyPasteHTML(range?.index, needsThemeAdaptation ? tempDiv.innerHTML : contentToInsert);
      // Update editor content
      const newContent = editor.root.innerHTML;
      setEditor(newContent);
      // Position cursor after pasted content
      setTimeout(() => {
        // Store the original document length to help determine added content
        const originalRange = range;

        try {
          // Get direct references to the Quill editor elements
          const editorRoot = editor.root;

          // Special handling for lists since they cause the most cursor problems
          const hasPastedLists = tempDiv.querySelector('li, ol, ul,br');

          if (hasPastedLists) {
            // For list content, we need to find the last list item or element
            // that was pasted and put cursor at its end

            // First, let's find all lists in the document
            const allLists = editorRoot.querySelectorAll('ol, ul');

            // Variables to track our findings
            let targetList = null;
            let lastItemOfList = null;

            // Go through all lists and find the one most likely to be what we just pasted
            // (the one closest to our paste position)
            for (let i = 0; i < allLists.length; i++) {
              const list = allLists[i];
              const listIndex = editor.getIndex(list);

              // If this list starts at or after our paste position
              // and is better than what we've found so far
              if (listIndex >= originalRange.index &&
                (!targetList || listIndex < editor.getIndex(targetList))) {
                targetList = list;
              }
            }

            // If we found a list, get its last item
            if (targetList) {
              const items = targetList.querySelectorAll('li');
              if (items.length > 0) {
                lastItemOfList = items[items.length - 1];
              }
            }

            // If we found the last item, position the cursor at its end
            if (lastItemOfList) {
              // Get the position right after the last item
              const itemIndex = editor.getIndex(lastItemOfList);
              const itemLength = lastItemOfList.textContent?.length || 0;

              // Position cursor after this last item
              editor.setSelection(itemIndex + itemLength, 0);
            } else {
              // Fallback - find position after the pasted content
              // by using original position + text length + structure count
              const contentLength = tempDiv.innerText.trim().length || 0;
              editor.setSelection(originalRange.index + contentLength + brCount, 0);
            }
          } else {
            // For non-list content, let's look for block elements like paragraphs and headings
            const blockElements = editorRoot.querySelectorAll('p, h1, h2, blockquote');

            // Find the last block element that was likely pasted
            let lastPastedBlock = null;
            let lastPastedBlockIndex = -1;

            for (let i = 0; i < blockElements.length; i++) {
              const block = blockElements[i];
              const blockIndex = editor.getIndex(block);

              // Only consider blocks at or after our original paste position
              if (blockIndex >= originalRange.index) {
                // Keep track of the block with the highest index (closest to paste position)
                if (blockIndex > lastPastedBlockIndex) {
                  lastPastedBlock = block;
                  lastPastedBlockIndex = blockIndex;
                }
              }
            }

            if (lastPastedBlock) {
              // Position cursor at the end of the last pasted block
              const blockLength = lastPastedBlock.textContent?.length || 0;
              editor.setSelection(lastPastedBlockIndex + blockLength, 0);
            } else {
              // No suitable block found, use text length approach with proper boundaries
              const textLength = tempDiv.innerText.trim().length || 0;
              const targetPosition = Math.min(
                originalRange.index + textLength,
                editor.getLength() - 1
              );
              editor.setSelection(targetPosition, 0);
            }
          }
        } catch (error) {
          // console.error("Error positioning cursor:", error);
          // Final fallback - move cursor slightly forward from where we started
          const textLength = tempDiv.innerText.trim().length || 0;
          editor.setSelection(Math.min(originalRange.index + textLength, editor.getLength() - 1), 0);
        }

        // Process task ID links after paste - fixes the paste recognition issue
        processTaskIdLinks(editor);

        // Apply colored text to headings when pasting (yellow for dark mode, blue for light mode)
        // const editorRoot = editor.root;
        // const headingsInEditor = editorRoot.querySelectorAll('h1, h2');
        // const headingColor = theme === 'dark' ? '#F4F504' : '#02a0ef';
        // headingsInEditor.forEach((heading: any) => {
        //   heading.style.setProperty('color', headingColor, 'important');
        //   // Also style all child elements (strong, span, em, etc.)
        //   const childElements = heading.querySelectorAll('*');
        //   childElements.forEach((child: any) => {
        //     child.style.setProperty('color', headingColor, 'important');
        //   });
        // });
      }, 150); // Slightly longer timeout to ensure content is fully rendered

    }
    else {
      // External content (e.g., from websites, blogs, etc.)
      const contentElement = tempDiv.querySelector('body') || tempDiv;
      const elementsToClean = contentElement.querySelectorAll('*');
      // Count structural elements for cursor positioning
      elementsToClean.forEach((element: any) => {
        if (element.tagName === 'BR' || element.tagName === 'UL' || element.tagName === 'OL' ||
          element.tagName === 'LI' || element.tagName === 'BLOCKQUOTE') {
          brCount++;
        }
        // Handle color adaptation more intelligently for external content
        // Remove background color if it would cause readability issues in current theme
        const computedStyle = window.getComputedStyle(element);
        const bgColor = element.style.backgroundColor || computedStyle.backgroundColor;
        const textColor = element.style.color || computedStyle.color;
        // Apply smart theme adaptation based on current theme
        if (theme === 'dark') {
          // For dark theme, ensure text is visible
          // Remove light backgrounds and only change near-black text to white
          // Preserve colors like red, blue, green that are readable on dark backgrounds
          if (isLightColor(bgColor)) {
            element.style.removeProperty('background-color');
          }
          if (isNearBlack(textColor)) {
            element.style.color = '#FFFFFF'; // Use light text for dark theme
          }
        } else {
          // For light theme, ensure text is visible
          // Remove dark backgrounds and light text that would be hard to read
          if (isDarkColor(bgColor)) {
            element.style.removeProperty('background-color');
          }
          if (isLightColor(textColor)) {
            element.style.color = '#000000'; // Use dark text for light theme
          }
        }
      });

      // Add a blank line after each original h2 heading (before converting h3-h6)
      const originalH2Headings = contentElement.querySelectorAll('h2');
      originalH2Headings.forEach((heading: any) => {
        const nextSibling = heading.nextElementSibling;
        // Add blank line after h2 if there is content below and it's not already a blank line
        if (nextSibling && !(nextSibling.tagName === 'P' && (nextSibling.innerHTML === '<br>' || nextSibling.innerHTML.trim() === ''))) {
          const blankLineAfter = document.createElement('p');
          blankLineAfter.innerHTML = '<br>';
          heading.parentNode?.insertBefore(blankLineAfter, heading.nextSibling);
        }
      });

      // Convert h3-h6 headings to h2
      const headingsToConvert = contentElement.querySelectorAll('h3, h4, h5, h6');
      headingsToConvert.forEach((heading: any) => {
        const h2 = document.createElement('h2');
        h2.innerHTML = heading.innerHTML;
        // Copy over attributes
        Array.from(heading.attributes).forEach((attr: any) => {
          h2.setAttribute(attr.name, attr.value);
        });
        heading.parentNode?.replaceChild(h2, heading);
      });

      editor.focus(); // Ensure the editor is active
      let range = editor.getSelection();
      // If no selection but editor has focus, get cursor position
      if (!range && editor.hasFocus()) {
        const cursorPosition = editor.getLength() - 1;
        range = { index: cursorPosition, length: 0 };
      }
      // If no selection and no focus, use start of document
      else if (!range) {
        range = { index: 0, length: 0 };
      }
      if (!range) return;
      const cleanHtml = contentElement === tempDiv
        ? tempDiv?.innerHTML
        : contentElement?.innerHTML;
      if (range?.length > 0) editor.deleteText(range.index, range.length);
      editor?.clipboard?.dangerouslyPasteHTML(range?.index, cleanHtml);
      // Update state
      const newContent = editor?.root?.innerHTML;
      setEditor(newContent);
      setTimeout(() => {
        // Store the original document length to help determine added content
        const originalRange = range;

        try {
          // Get direct references to the Quill editor elements
          const editorRoot = editor.root;

          // Special handling for lists since they cause the most cursor problems
          const hasPastedLists = tempDiv.querySelector('li, ol, ul');

          if (hasPastedLists) {
            // For list content, we need to find the last list item or element
            // that was pasted and put cursor at its end

            // First, let's find all lists in the document
            const allLists = editorRoot.querySelectorAll('ol, ul');

            // Variables to track our findings
            let targetList = null;
            let lastItemOfList = null;

            // Go through all lists and find the one most likely to be what we just pasted
            // (the one closest to our paste position)
            for (let i = 0; i < allLists.length; i++) {
              const list = allLists[i];
               const blot = Quill.find(list);
              const listIndex = editor.getIndex(blot);

              // If this list starts at or after our paste position
              // and is better than what we've found so far
              if (listIndex >= originalRange.index &&
                (!targetList || listIndex < editor.getIndex(targetList))) {
                targetList = list;
              }
            }

            // If we found a list, get its last item
            if (targetList) {
              const items = targetList.querySelectorAll('li');
              if (items.length > 0) {
                lastItemOfList = items[items.length - 1];
              }
            }

            // If we found the last item, position the cursor at its end
            if (lastItemOfList) {
              // Get the position right after the last item
              const itemIndex = editor.getIndex(lastItemOfList);
              const itemLength = lastItemOfList.textContent?.length || 0;

              // Position cursor after this last item
              editor.setSelection(itemIndex + itemLength, 0);
            } else {
              // Fallback - find position after the pasted content
              // by using original position + text length + structure count
              const contentLength = tempDiv?.innerText?.trim()?.length || 0;
              editor.setSelection(originalRange.index + contentLength + brCount, 0);
            }
          } else {
            // For non-list content, let's try a more direct approach
            // Calculate text length and add any br tags for structure
            const contentLength = tempDiv?.innerText?.trim()?.length || 0;
            const structureAdjustment = Math.max(0, brCount);

            // Set cursor position accounting for text and structure
            const targetPosition = Math.min(
              originalRange.index + contentLength + structureAdjustment,
              editor.getLength() - 1
            );

            editor.setSelection(targetPosition, 0);
          }
        } catch (error) {
          // console.error("Error positioning cursor:", error);
          // Final fallback - move cursor forward by content length from where we started
          const textLength = tempDiv?.innerText?.trim()?.length || 0;
          editor.setSelection(Math.min(originalRange.index + textLength, editor.getLength() - 1), 0);
        }

        // Process task ID links after paste - fixes the paste recognition issue
        processTaskIdLinks(editor);

        // Apply colored text to headings when pasting (yellow for dark mode, blue for light mode) - external content
        const editorRoot = editor.root;
        const headingsInEditor = editorRoot.querySelectorAll('h1, h2');
        const headingColor = theme === 'dark' ? '#F4F504' : '#02a0ef';
        headingsInEditor.forEach((heading: any) => {
          heading.style.setProperty('color', headingColor, 'important');
          // Also style all child elements (strong, span, em, etc.)
          const childElements = heading.querySelectorAll('*');
          childElements.forEach((child: any) => {
            child.style.setProperty('color', headingColor, 'important');
          });
        });
      }, 150); // Slightly longer timeout to ensure content is fully rendered
    }
  };
  // Utility functions to determine if a color is light or dark
  const isLightColor = (color: string): boolean => {
    if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') return false;
    // Extract RGB components
    const rgb = color.match(/\d+/g);
    if (!rgb || rgb.length < 3) return false;
    // Calculate luminance (simplified)
    const luminance = (parseInt(rgb[0]) * 0.299 + parseInt(rgb[1]) * 0.587 + parseInt(rgb[2]) * 0.114) / 255;
    return luminance > 0.6; // Higher values are lighter colors
  };
  const isDarkColor = (color: string): boolean => {
    if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') return false;
    // Extract RGB components
    const rgb = color.match(/\d+/g);
    if (!rgb || rgb.length < 3) return false;
    // Calculate luminance (simplified)
    const luminance = (parseInt(rgb[0]) * 0.299 + parseInt(rgb[1]) * 0.587 + parseInt(rgb[2]) * 0.114) / 255;
    return luminance < 0.4; // Lower values are darker colors
  };
  // Check if color is near-black (very dark, unreadable on dark backgrounds)
  // This preserves colors like red, blue, green that are readable on dark backgrounds
  const isNearBlack = (color: string): boolean => {
    if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') return false;
    const rgb = color.match(/\d+/g);
    if (!rgb || rgb.length < 3) return false;
    const r = parseInt(rgb[0]);
    const g = parseInt(rgb[1]);
    const b = parseInt(rgb[2]);
    // Only consider it near-black if all RGB values are very low (< 50)
    return r < 50 && g < 50 && b < 50;
  };

  // Process pasted content for task ID links - handles the paste recognition issue
  const processTaskIdLinks = (editor: any) => {
    if (!boardId) return;

    const content = editor.root.innerHTML;
    const processedContent = processHtml(content);

    // Check for task ID patterns in the pasted content
    const taskIdPattern = /\/[A-Z]+-\d+/g;
    const matches = processedContent.match(taskIdPattern);

    if (matches && matches.length > 0) {
      let updatedContent = processedContent;

      // Process card links
      updatedContent = updatedContent.replace(/\/[^#\s]*\d[^\s]*/g, (match: string) => {
        const cleanMatch = match.replace(/amp;/g, '');
        const matchingCard = allCurrentUserCards?.find((card: any) => {
          const cardPattern = `/${card?.key?.trim()}`;
          return cardPattern === cleanMatch;
        });
        if (matchingCard && !match.includes('<a')) {
          return `<a href="#">${match}</a>`;
        }
        return match;
      });

      // Process page links
      updatedContent = updatedContent.replace(/\/[^#\s]*\d[^\s]*/g, (match: string) => {
        const cleanMatch = match.replace(/amp;/g, '');
        const matchingPage = pages?.find((page: any) => {
          const pagePattern = `/${page?.key?.trim()}`;
          return pagePattern === cleanMatch;
        });
        if (matchingPage && !match.includes('<a')) {
          return `<a href="#">${match}</a>`;
        }
        return match;
      });

      setEditor(updatedContent);

      // Apply link styling to any newly created links
      setTimeout(() => {
        const customLinks = document.querySelectorAll<HTMLAnchorElement>(
          'div.ql-editor[contenteditable="true"] a'
        );

        Array.from(customLinks).forEach((link) => {
          if (/\/\S*-\d+\b/.test(link.innerText)) {
            link.setAttribute(
              'style',
              `max-width: 30%; cursor: pointer; text-decoration: underline; display: inline; color: ${theme === 'dark' ? '#98C6F9' : '#0067c5'};`
            );
            link.setAttribute('id', link.innerText);
            link.classList.add('pattern-class');
            link.addEventListener('mouseover', (e) => {
              e.preventDefault();
              debouncedOnChange(link.innerText.replace(/[/#]/g, '').trim());
            });
            link.setAttribute(
              'data-tooltip-id',
              `my-tooltip-children-multiline-write-${link.innerText.replace(/[#/]/g, '').trim()}`
            );
          }
        });
      }, 50);
    }
  };

  // Trigger mention dropdown for pasted task IDs by directly calling mention module
  const triggerMentionForPastedId = (editor: any, pastedText: string, pasteStartIndex: number) => {
    if (!boardId) return;

    const trimmedText = pastedText.trim();
    // Check if pasted text starts with a mention denotation character
    const mentionPattern = /^[/#@]/;
    if (!mentionPattern.test(trimmedText)) {
      // If doesn't start with mention char, process for existing task links
      processTaskIdLinks(editor);
      return;
    }

    // Position cursor at end of pasted text
    const endPosition = pasteStartIndex + trimmedText.length;
    editor.setSelection(endPosition);

    // Get the mention module and directly trigger the search
    const mentionModule = editor.getModule('mention');
    if (mentionModule && typeof mentionModule.onSomethingChange === 'function') {
      // Small delay to ensure editor state is settled
      setTimeout(() => {
        // Call the mention module's internal method to trigger search
        mentionModule.onSomethingChange();
      }, 50);
    } else {
      // Fallback: process task ID links if mention module not available
      processTaskIdLinks(editor);
    }
  };

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;
    // Remove any existing listeners first
    editor.root.removeEventListener('paste', handlePaste);
    editor.root.removeEventListener('copy', handleCopy);

    editor.root.addEventListener('paste', handlePaste, { capture: true });
    editor.root.addEventListener('copy', handleCopy, { capture: true });

    return () => {
      editor.root.removeEventListener('paste', handlePaste, { capture: true });
      editor.root.removeEventListener('copy', handleCopy, { capture: true });
    };
  }, [theme]);
  const processHtml = (content: string) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    // Process elements in the content for theme-appropriate styling
    let needsStyleAdaptation = false;
    const elementsToProcess = tempDiv.querySelectorAll('*');
    elementsToProcess.forEach((element: any) => {
      // Skip processing elements that shouldn't have their styles changed
      if (element.classList.contains('mention') ||
        element.tagName === 'A' ||
        element.classList.contains('pattern-class')) {
        return;
      }
      const bgColor = element.style.backgroundColor;
      const textColor = element.style.color;
      if (bgColor || textColor) {
        // Check if colors need adaptation for current theme
        if (theme === 'dark') {
          // For dark theme
          if (bgColor && isLightColor(bgColor)) {
            // element.style.backgroundColor = 'transparent';
            needsStyleAdaptation = true;
          }
          if (textColor && isDarkColor(textColor)) {
            // element.style.color = '#FFFFFF';
            needsStyleAdaptation = true;
          }
        } else {
          // For light theme
          if (bgColor && isDarkColor(bgColor)) {
            // element.style.backgroundColor = 'transparent';
            needsStyleAdaptation = true;
          }
          if (textColor && isLightColor(textColor) && textColor !== 'rgb(0, 103, 197)') {
            // Preserve blue link color but adapt other light colors
            // element.style.color = '#000000';
            needsStyleAdaptation = true;
          }
        }
      }
    });
    const processedContent = needsStyleAdaptation ? tempDiv.innerHTML : content;
    return processedContent

  }
  const handleChange = (content: string, delta: any, source: string) => {
    if (source === 'user') {

      const processedContent = processHtml(content)
      // Use the adapted content if changes were made

      if (boardId) {
        const replacedContent = processedContent.replace(/\/[^#\s]*\d[^\s]*/g, (match) => {
          const replacedContent1 = match.replace(/amp;/g, '');
          const matchingCard = allCurrentUserCards?.find((card: any) => {
            const cardPattern = `/${card?.key?.trim()}`
            return cardPattern === replacedContent1
          })
          if (matchingCard) {
            return `<a href="#">${match}</a>`
          } else {
            return match
          }
        })
        const replacedContentForPage = processedContent.replace(/\/[^#\s]*\d[^\s]*/g, (match) => {
          const replacedContent1 = match.replace(/amp;/g, '');
          const matchingPage = pages?.find((page: any) => {
            const pagePattern = `/${page?.key?.trim()}`
            return pagePattern === replacedContent1
          })
          if (matchingPage) {
            return `<a href="#">${match}</a>`
          } else {
            return match
          }
        })
        setEditor(replacedContent)
        setEditor(replacedContentForPage)
        setMentions && extractMentionText(processedContent, setMentions, retainMentions)
      } else {
        setEditor(processedContent)
      }
    }

    const customLinks = document.querySelectorAll<HTMLAnchorElement>(
      'div.ql-editor[contenteditable="true"] a'
    )

    if (customLinks.length > 0) {
      Array.from(customLinks).forEach((link) => {
        if (/\/\S*-\d+\b/.test(link.innerText)) {
          link.setAttribute(
            'style',
            `max-width: 30%; cursor: pointer; text-decoration: underline; display: inline; color: ${theme === 'dark' ? '#98C6F9' : '#0067c5'};`
          )

          link.setAttribute('id', link.innerText)

          link.classList.add('pattern-class')
          link.addEventListener('mouseover', (e) => {
            e.preventDefault()
            debouncedOnChange(link.innerText.replace(/[/#]/g, '').trim())
          })
          link.setAttribute(
            'data-tooltip-id',
            `my-tooltip-children-multiline-write-${link.innerText.replace(/[#/]/g, '').trim()}`
          );


          // link.addEventListener('click', (e) => {
          //   e.preventDefault()
          //   if (handleFormSubmission) {
          //     debugger
          //     handleFormSubmission()
          //   }
          //   if(!linkClickLoading){
          //     setCard(
          //       allCurrentUserCards?.find(
          //         (card: any) => `${card?.key.trim()}` === link.innerText.replace('/', '').trim()
          //       )
          //     )

          //     setShowEditModalQuill(true)
          //     setCardSelected(null)
          //   }

          // })
        }
      })
    }

    const mentionsEle = document.querySelectorAll<HTMLAnchorElement>(
      'div.ql-editor[contenteditable="true"] .mention'
    )

    Array.from(mentionsEle).forEach((link) => {
      link.setAttribute(
        'data-tooltip-id',
        `my-tooltip-children-multiline-write-${link
          ?.querySelector('span')
          ?.innerHTML.trim()
          ?.replace(/[#/]/g, '')}`
      )
    })

    // Apply correct heading colors whenever content changes
    const quill = quillRef.current?.getEditor();
    if (quill) {
      const editorRoot = quill.root;
      const headingsInEditor = editorRoot.querySelectorAll('h1, h2');
      const headingColor = theme === 'dark' ? '#F4F504' : '#02a0ef';
      headingsInEditor.forEach((heading: any) => {
        heading.style.setProperty('color', headingColor, 'important');
        // Also style all child elements (strong, span, em, etc.)
        const childElements = heading.querySelectorAll('*');
        childElements.forEach((child: any) => {
          child.style.setProperty('color', headingColor, 'important');
        });
      });
    }

    handleMedia()
  }

  const onBlur = (previousSelection: any, source: any, editor: any) => {
    const content = editor.getHTML()

    const processedContent = processHtml(content)

    const upContent = processedContent.replaceAll('</p>', '  </p>')
    const nextCont = upContent.replaceAll('<p>', '  <p>  ')
    if (source === 'user') {
      if (boardId) {
        const replacedContent = nextCont.replace(/\/[^#\s]*\d[^\s]*/g, (match: any) => {
          const matchingCard = allCurrentUserCards?.find((card: any) => {
            const cardPattern = `/${card?.key.trim()}`
            return cardPattern === match
          })
          if (matchingCard) {
            return `<a href="#">${match}</a>`
          } else {
            return match
          }
        })

        const replacedContentForPage = nextCont.replace(/\/[^#\s]*\d[^\s]*/g, (match: any) => {
          const replacedContent1 = match.replace(/amp;/g, '');
          const matchingPage = pages?.find((page: any) => {
            const pagePattern = `/${page?.key?.trim()}`
            return pagePattern === replacedContent1
          })
          if (matchingPage) {
            return `<a href="#">${match}</a>`
          } else {
            return match
          }
        })
        setEditor(replacedContent)
        setEditor(replacedContentForPage)
        setMentions && extractMentionText(processedContent, setMentions, retainMentions)

      } else {
        setEditor(processedContent)
      }

    }
    const customLinks = document.querySelectorAll<HTMLAnchorElement>(
      'div.ql-editor[contenteditable="true"] a'
    )


    if (customLinks.length > 0) {
      Array.from(customLinks).forEach((link) => {
        if (/\/\S*-\d+\b/.test(link.innerText)) {
          link.setAttribute(
            'style',
            `max-width: 30%; cursor: pointer; text-decoration: underline; display: inline; color: ${theme === 'dark' ? '#98C6F9' : '#0067c5'};`
          )

          link.setAttribute('id', link.innerText)

          link.classList.add('pattern-class')
          link.addEventListener('mouseover', () => {
            debouncedOnChange(link.innerText.replace(/#]/g, '').trim())
          })
          link.setAttribute(
            'data-tooltip-id',
            `my-tooltip-children-multiline-write-${link.innerText.replace(/[/#]/g, '').trim()}`
          );


          // link.addEventListener('click', (e) => {
          //   e.preventDefault()
          //   if (handleFormSubmission) {
          //     handleFormSubmission()
          //   }
          //   if(!linkClickLoading){
          //     setCard(
          //       allCurrentUserCards?.find(
          //         (card: any) => `${card?.key.trim()}` === link.innerText.replace('/', '').trim()
          //       )
          //     )

          //     setShowEditModalQuill(true)
          //     setCardSelected(null)
          //   }
          // })
        }
      })
    }
  }

  function handleMedia() {
    const editImg: any = document.querySelectorAll(`div.ql-editor[contenteditable="true"] img`)
    const videoIframe: any = document.querySelectorAll(
      `div.ql-editor[contenteditable="true"] iframe`
    )

    if (videoIframe.length > 0) {
      setIsVideoSrcGet(true)
    }

    for (let i = 0; i < editImg.length; i++) {
      editImg[i].style.maxWidth = '30%'
      editImg[i].classList.add('m-2')
      editImg[i].classList.add('cursor-pointer')

      editImg[i].addEventListener('click', () => {
        const imageSrc: any = editImg[i].getAttribute('src')
        editRef.current?.handleModal(imageSrc)
      })
    }
  }

  const onHover = (event: any) => {
    handleMouseover(event.value.id)
  }

  const onMentionClick = (event: any) => {
    // Only handle if the click originated within this editor instance
    const clickTarget = event.event?.target || event.event?.srcElement
    const editorRoot = quillRef.current?.getEditor?.()?.root || editRef.current
    if (editorRoot && clickTarget && !editorRoot.contains(clickTarget)) {
      return
    }

    if (event.value.denotationChar !== '@') {
      if (handleFormSubmission) {
        // Push current card/page to history before opening the new one
        if (currentCardOrPage && currentCardOrPage.id) {
          pushToHistory(currentCardOrPage)
        }
        handleFormSubmission()
        setExpandedFromSource(!!isExpandedModalRef.current)
        if (event.value.denotationChar === '/') {
          setCard(
            allCurrentUserCards?.find((card: any) => `${card?.key.trim()}` === (event.value.id?.trim() || event.value.value?.trim())))
        } else {
          setCard(
            pages?.find((page: any) => `${page?.id}` === event.value.id)
          )
        }
        setShowEditModalQuill(true)
        setCardSelected(null)
      }
    }
  }

  const mentionDebounceOnHover = debounce(onHover, 300)

  useEffect(() => {
    window.addEventListener('mention-hovered', mentionDebounceOnHover, false)
    window.addEventListener('mention-clicked', onMentionClick, false)
    if (editor) {
      handleChange(editor, 0, 'user')
    }
    return () => {
      window.removeEventListener('mention-hovered', mentionDebounceOnHover, false)
      window.removeEventListener('mention-clicked', onMentionClick, false)
    }
    //eslint-disable-next-line
  }, [])

  const scrollToMention = () => {
    if (editor) {
      const quillEditor = quillRef.current.getEditor();
      const targetMention = [...quillEditor.root.querySelectorAll("p span")].find(span => span.getAttribute("data-unique-id") === uniqueId);
      if (!targetMention) {
        return;
      }
      //scroll to uniqueid mention
      const headingElement = targetMention;
      const rect = headingElement.getBoundingClientRect();
      const editorRect = quillEditor.root.getBoundingClientRect();
      const scrollTop = rect.top - editorRect.top + quillEditor.root.scrollTop;
      quillEditor.root.scrollTop = scrollTop;
    }
  };

  const scrollToHeading = () => {
    if (editor) {
      const quillEditor = quillRef.current.getEditor();
      const headingElements = quillEditor.root.querySelectorAll('h1, h2');

      for (let i = 0; i < headingElements.length; i++) {
        if (i === tocHeading?.index) {
          const headingElement = headingElements[i];
          const rect = headingElement.getBoundingClientRect();
          const editorRect = quillEditor.root.getBoundingClientRect();
          const scrollTop = rect.top - editorRect.top + quillEditor.root.scrollTop;

          quillEditor.root.scrollTop = scrollTop;
          break;
        }
      }
    }
  };

  const getHtmlTags = (editor: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(editor, 'text/html');

    const headings = doc.querySelectorAll<HTMLHeadingElement>('h1, h2');

    const combinedTags = Array.from(headings).map((tag, index) => ({
      name: tag.textContent,
      tagName: tag.tagName.toLowerCase(),
      index,
    }));

    setEditorTags(combinedTags);
  }

  useEffect(() => {
    if (editor) {
      getHtmlTags(editor)
    }
  }, [editor])

  useEffect(() => {
    if (tocHeading) {
      scrollToHeading()
    }
  }, [tocHeading, editor])
  useEffect(() => {
    if (uniqueId) {
      scrollToMention()
    }
  }, [uniqueId, editor])


  const formats = useMemo(
    () => [
      'header',
      'font',
      'size',
      'bold',
      'italic',
      'underline',
      'align',
      'strike',
      'script',
      'blockquote',
      'background',
      'list',
      'bullet',
      'indent',
      'link',
      'image',
      'video',
      'color',
      'code-block',
      'mention',
    ],
    []
  )

  function CardData({ data }: { data: string }): React.ReactElement {
    return <span dangerouslySetInnerHTML={createSafeHtml(data, 'default')} />
  }
  async function suggestPeople(searchTerm: any) {
    const filteredCards = allCurrentUserCards?.filter((c: any) => c.boardId === boardId)

    const cardIds =
      filteredCards?.length > 0 &&
      filteredCards?.map((card: any) => ({
        id: `${card?.key.trim()}`,
        value: `${card?.key.trim()}`,
      }))

    cardIds?.length > 0 &&
      cardIds?.sort((a: any, b: any) => {
        return a.value.localeCompare(b.value)
      })

    return cardIds?.length > 0 && cardIds?.filter((person: any) => person.value.includes(searchTerm))
  }
  async function suggestPages(searchTerm: any) {

    const filteredPages = pages?.filter((p: any) =>
      p.boardId === boardId &&
      p.board_people.find((bp: any) => bp.user.fullName === fullName) &&
      p.key &&
      !p.key.includes("undefined")
    );

    const pageIds = filteredPages
      ?.filter((page: any) => page?.key)
      ?.map((page: any) => ({
        id: page.id,
        value: page.key.trim(),
      }));


    pageIds && pageIds?.length > 0 &&
      pageIds?.sort((a: any, b: any) => {
        return a.value.localeCompare(b.value)
      })

    return pageIds?.length > 0 && pageIds?.filter((person: any) => person.value.includes(searchTerm))
  }
  async function suggestAlertOptions(searchTerm: any) {
    const options = optionsForSendAlert
      ?.map((option: any) => ({
        id: option.value,
        value: option.label,
      }));

    options?.length > 0 &&
      options?.sort((a: any, b: any) => {
        return a.value.localeCompare(b.value)
      })
    return options?.length > 0 && options?.filter((option: any) => option.value.includes(searchTerm))
  }
  // Handlers for custom buttons
  const handleCustomMentionTrigger = (char: '@ ' | '/ ' | '# ') => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = quill.getSelection();
    if (!range) return;

    quill.focus(); // Ensure the editor is active

    // ✅ Insert the mention character and move the cursor forward
    quill.insertText(range.index, char);
    quill.setSelection(range.index + 1);

    // ✅ Simulate a real keypress event
    setTimeout(() => {
      const keyMap: Record<string, number> = {
        '@': 50, // KeyCode for '@'
        '/': 191, // KeyCode for '/'
        '#': 51, // KeyCode for '#'
      };

      const event = new KeyboardEvent('keydown', {
        key: char,
        code: `Digit${keyMap[char]}`,
        keyCode: keyMap[char],
        which: keyMap[char],
        bubbles: true,
      });

      quill.root.dispatchEvent(event);
    }, 100);
  };

  // Emoji picker handlers
  const handleEmojiClick = (emojiData: EmojiClickData) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    // Use saved cursor position or get current selection
    let range = savedCursorPosition.current || quill.getSelection();

    // If no selection (cursor not in editor), insert at the end
    if (!range) {
      const length = quill.getLength();
      range = { index: length - 1, length: 0 };
    }

    quill.insertText(range.index, emojiData.emoji);
    quill.setSelection(range.index + emojiData.emoji.length);

    const newContent = quill.root.innerHTML;
    setEditor(newContent);
    setShowEmojiPicker(false);

    // Clear saved position
    savedCursorPosition.current = null;
  };

  const handleEmojiButtonClick = () => {
    const quill = quillRef.current?.getEditor();
    if (quill) {
      // Save current cursor position before opening picker
      savedCursorPosition.current = quill.getSelection();
    }
    setShowEmojiPicker(!showEmojiPicker);
  };

  // Close emoji picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target as Node)) {
        const emojiButton = document.querySelector('.ql-customButtonEmoji');
        if (emojiButton && !emojiButton.contains(event.target as Node)) {
          setShowEmojiPicker(false);
        }
      }
    };

    if (showEmojiPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showEmojiPicker]);

  // Handle highlight color picker button click
  const handleHighlightButtonClick = () => {
    const quill = quillRef.current?.getEditor();
    if (quill) {
      savedCursorPosition.current = quill.getSelection();
    }
    setShowHighlightPicker(!showHighlightPicker);
  };

  // Apply highlight color to selected text
  const applyHighlightColor = (color: string, closePicker: boolean = true) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = savedCursorPosition.current || quill.getSelection();
    if (range && range.length > 0) {
      quill.formatText(range.index, range.length, 'background', color);
      setEditor(quill.root.innerHTML);
    }
    setHighlightColor(color);
    if (closePicker) {
      setShowHighlightPicker(false);
      savedCursorPosition.current = null;
    }
  };

  // Close highlight picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (highlightPickerRef.current && !highlightPickerRef.current.contains(event.target as Node)) {
        const highlightButton = document.querySelector('.ql-customButtonHighlight');
        if (highlightButton && !highlightButton.contains(event.target as Node)) {
          setShowHighlightPicker(false);
        }
      }
    };

    if (showHighlightPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showHighlightPicker]);

  // Handle text color picker button click
  const handleTextColorButtonClick = () => {
    const quill = quillRef.current?.getEditor();
    if (quill) {
      savedCursorPosition.current = quill.getSelection();
    }
    setShowTextColorPicker(!showTextColorPicker);
  };

  // Apply text color to selected text
  const applyTextColor = (color: string, closePicker: boolean = true) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = savedCursorPosition.current || quill.getSelection();
    if (range && range.length > 0) {
      quill.formatText(range.index, range.length, 'color', color);
      setEditor(quill.root.innerHTML);
    }
    setTextColor(color);
    if (closePicker) {
      setShowTextColorPicker(false);
      savedCursorPosition.current = null;
    }
  };

  // Close text color picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (textColorPickerRef.current && !textColorPickerRef.current.contains(event.target as Node)) {
        const textColorButton = document.querySelector('.ql-customButtonTextColor');
        if (textColorButton && !textColorButton.contains(event.target as Node)) {
          setShowTextColorPicker(false);
        }
      }
    };

    if (showTextColorPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTextColorPicker]);

  const modules = useMemo(
    () => ({
      toolbar:
      {
        container:
          [
            [{ header: [1, 2, false] }],
            [{ 'size': ['small',false, 'large'] }],
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ align: [] }],
            ['customButtonTextColor', 'customButtonHighlight'], // custom text color picker + custom highlight picker
            // [{ font: [] }],
            ['image'],
            ['video'],
            ['link'],
            ...(boardId
              ? [
                ['customButtonMention'],
                ['customButtonLink'],
                ['customButtonPage'],
              ]
              : []),
              ['customButtonEmoji'],
          ],
        handlers: {
          customButtonMention: () => handleCustomMentionTrigger('@ '),
          customButtonLink: () => handleCustomMentionTrigger('/ '),
          customButtonPage: () => handleCustomMentionTrigger('# '),
          customButtonEmoji: handleEmojiButtonClick,
          customButtonHighlight: handleHighlightButtonClick,
          customButtonTextColor: handleTextColorButtonClick,
        },
      },

      mention: {
        // mentionContainerClass:  theme === 'dark' ? 'theme__div' : '',
        mentionListClass: theme === 'dark' ? 'theme__div' : '',

        allowedChars: /^[A-Za-z\sÅÄÖåäö\d=+\-_)(*&^%$#@![\]{}';:"/.,?><\\|]*$/,
        mentionDenotationChars: ['/', '#', '@'],
        spaceAfterInsert: false,
        maxChars: 300,
        source: async function (searchTerm: any, renderList: any, mentionChar: any) {
          if (mentionChar === '/') {
            const matchedPeople = await suggestPeople(searchTerm.slice(1));
            renderList(matchedPeople, searchTerm);
          } else if (mentionChar === '#') {
            const matchedPages = await suggestPages(searchTerm.slice(1));
            renderList(matchedPages, searchTerm);
          } else if (mentionChar === '@') {
            const matchedPeople = await suggestAlertOptions(searchTerm.slice(1));
            renderList(matchedPeople, searchTerm);

          } else {
            renderList([], searchTerm); // No valid character
          }
        },
        onSelect: function (item: any, insertItem: any) {
          insertItem(item); // Insert the mention
          if (item.denotationChar === '@') {
            setTimeout(() => {
              // Modify the inserted mention element
              const mentions = document.querySelectorAll(`[data-id="${item.id}"]`);
              mentions.forEach((mention) => {
                const vvid = uuidv4();
                mention.setAttribute('data-unique-id', vvid);
                mention.setAttribute('data-description', 'new');
              });
            }, 0); // Delay to ensure DOM update
          }
        },
      },
    }),

    []
  )

  useEffect(() => {
    if (!quillRef.current) return;

    const quill = quillRef.current.getEditor();
    quill.root.addEventListener('keydown', handleKeyDown);

    return () => {
      quill.root.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e: any) => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    if (e.key === 'Tab') {
      if (range) {
        setTimeout(() => {
          quill.removeFormat(range.index + 1, 0);
        }, 0);
      }
    }
  };

  return (
    <>
      <div className={`text-editor bg-white  ${isHome && 'home_editor'} ${theme === 'dark' ? `dark-mode-placeholder` : ''}`} style={{ position: 'relative' }}>
        <ReactQuill
          theme='snow'
          value={editor ? editor : ''}
          onChange={handleChange}
          placeholder={placeholder}
          modules={modules}
          formats={formats}
          ref={quillRef}
          tabIndex={tabIndex}
          className={`image_resize_textEditor  ${theme === 'dark'
            ? (isHome ? 'layout__dark__div' : 'dark__theme__input')
            : (isHome ? 'text-dark white_editor__placeholder' : '')
            }`}
          onBlur={onBlur}
          // readOnly={forTitle === 'description' && role?.isGuest === true}
          readOnly={role && role === 'Guest' ? true : false}
        />

        {showEmojiPicker && (
          <div
            ref={emojiPickerRef}
            style={{
              position: 'absolute',
              top: '50px',
              right: '10px',
              zIndex: 1000,
            }}
          >
            <EmojiPicker
              onEmojiClick={handleEmojiClick}
              theme={theme === 'dark' ? Theme.DARK : Theme.LIGHT}
              width={350}
              height={400}
            />
          </div>
        )}

        {showTextColorPicker && (
          <div
            ref={textColorPickerRef}
            className={`highlight-picker ${theme === 'dark' ? 'dark' : ''}`}
          >
            <div className="highlight-picker__header">
              <span className="highlight-picker__title">
                Text Color
              </span>
              <input
                ref={textColorInputRef}
                type="color"
                value={textColor}
                onChange={(e) => applyTextColor(e.target.value, false)}
                className="highlight-picker__color-input"
                title="Custom color"
              />
              <button
                type="button"
                onClick={() => textColorInputRef.current?.click()}
                className="highlight-picker__brush-btn"
                title="More Colors"
              >
                <i className="bi bi-brush-fill"></i>
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowTextColorPicker(false);
                  savedCursorPosition.current = null;
                }}
                className="highlight-picker__done-btn"
                title="Close"
              >
                Done
              </button>
            </div>
            <div className="highlight-picker__colors">
              {highlightPickerColors.map((color, index) => (
                <div
                  key={index}
                  onClick={() => applyTextColor(color)}
                  className={`highlight-picker__color-swatch ${textColor.toLowerCase() === color.toLowerCase() ? 'selected' : ''}`}
                  style={{ backgroundColor: color }}
                  title={color}
                />
              ))}
            </div>
          </div>
        )}

        {showHighlightPicker && (
          <div
            ref={highlightPickerRef}
            className={`highlight-picker ${theme === 'dark' ? 'dark' : ''}`}
          >
            <div className="highlight-picker__header">
              <span className="highlight-picker__title">
                Highlight Color
              </span>
              <input
                ref={colorInputRef}
                type="color"
                value={highlightColor}
                onChange={(e) => applyHighlightColor(e.target.value, false)}
                className="highlight-picker__color-input"
                title="Custom color"
              />
              <button
                type="button"
                onClick={() => colorInputRef.current?.click()}
                className="highlight-picker__brush-btn"
                title="More Colors"
              >
                <i className="bi bi-brush-fill"></i>
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowHighlightPicker(false);
                  savedCursorPosition.current = null;
                }}
                className="highlight-picker__done-btn"
                title="Close"
              >
                Done
              </button>
            </div>
            <div className="highlight-picker__colors">
              {highlightPickerColors.map((color, index) => (
                <div
                  key={index}
                  onClick={() => applyHighlightColor(color)}
                  className={`highlight-picker__color-swatch ${highlightColor.toLowerCase() === color.toLowerCase() ? 'selected' : ''}`}
                  style={{ backgroundColor: color }}
                  title={color}
                />
              ))}
            </div>
          </div>
        )}

        {cardSelected && (
          <ReactToolTip id={`my-tooltip-children-multiline-write-${cardSelected?.key?.trim()}`}>
            <div id='react-tooltip-custom'>
              <div className='custom-card'>
                <h5 className={theme === 'dark' ? 'white__text' : ''} style={{ margin: 0, textDecoration: 'underline' }}>{cardSelected?.card_name}</h5>
                <span className='custom-card-description'>
                  {cardSelected?.description ? (
                    <CardData data={cardSelected?.description} />
                  ) : (
                    <CardData
                      data={`<span>
                    No Description
                  </span>`}
                    />
                  )}
                </span>
              </div>
            </div>
          </ReactToolTip>
        )}
        {pageSelected && (
          <ReactToolTip id={`my-tooltip-children-multiline-write-${pageSelected?.key?.trim()}`}>
            <div id='react-tooltip-custom'>
              <div className='custom-card'>
                <h5 className={theme === 'dark' ? 'white__text' : ''} style={{ margin: 0, textDecoration: 'underline' }}>{pageSelected?.title}</h5>
                <span className='custom-card-description'>
                  {pageSelected?.description ? (
                    <CardData data={pageSelected?.description} />
                  ) : (
                    <CardData
                      data={`<span>
                    No Description
                  </span>`}
                    />
                  )}
                </span>
              </div>
            </div>
          </ReactToolTip>
        )}
      </div>

      {isVideoSrcGet && (
        <p>
          If video is not preview or loaded properly! Kindly disable any ad blockers or
          privacy-related browser extensions temporarily
        </p>
      )}
      <ImageModal ref={editRef} />
    </>
  )
}

export const TextEditor = React.memo(MemoizedTextEditor)